import axios from '@/axios'

class MaintenanceStatusProvider {
  async GetMaintenanceStatus (complexid) {
    let result = await axios.get('maintenancestatus/' + complexid + '')
    return result.data
  }
}

export default new MaintenanceStatusProvider()



// WEBPACK FOOTER //
// ./src/providers/MaintenanceStatusProvider.js